<template>
  <div class="table-page-search-wrapper">
    <a-form :layout="layout">
      <a-row :gutter="gutter">
        <a-col :md="spanMd" :sm="24">
          <a-form-item 
            label="合同名称"
           :labelCol="labelCol"
           :wrapperCol="wrapperCol"
          >
            <a-input placeholder="请输入合同名称" :allowClear="true" autocomplete="off" v-model="searchModel.name" />
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item 
            label="合同编号"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input placeholder="请输入合同编号" :allowClear="true" autocomplete="off" v-model="searchModel.number" />
          </a-form-item> </a-col
        ><a-col :md="spanMd" :sm="24">
          <a-form-item 
            label="甲方名称"
           :labelCol="labelCol"
           :wrapperCol="wrapperCol"
          >
            <a-select v-model="searchModel.partyId" :allowClear="true" placeholder="请选择甲方名称">
              <a-select-option v-for="(item, index) in partyNameList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="4" :sm="24">
          <span
            class="table-page-search-submitButtons"
            :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
          >
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { getProprietorsList } from '@/api/proprietors'
import { mapState } from 'vuex'
export default {
  name: 'saleSearchForm',
  mounted() {
    this.getSelectPartyNameList()
  },
  computed: {
    ...mapState({}),
  },
  data() {
    return {
      layout: 'inline',
      gutter: 48,
      spanMd: 6,
      spanSm: 24,
      showExpend: true,
      partyNameList: [],
      searchModel: {},
      advanced: false, //是否展开
      labelCol:{ xs: { span: 24 }, sm: { span: 8 } },
      wrapperCol:{ xs: { span: 24 }, sm: { span: 15 } }
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search() {
      for (var key in this.searchModel) {
        if (this.searchModel[key] === undefined || this.searchModel[key] === null || this.searchModel[key] === '') {
          delete this.searchModel[key]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch() {
      this.searchModel = {}
      this.$emit('clearSearch', this.searchModel)
    },
    // 获取select列表
    getSelectPartyNameList() {
      getProprietorsList({ paging: false }).then((res) => {
        if (res.status === 0) {
          this.partyNameList = res.data
        }
      })
    },
  },
}
</script>

<style scoped lang="less"></style>

